import './ListChooser.scss';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { AuthContext, ToastContext } from '../../context';
import { collection, doc, onSnapshot, query, updateDoc, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { Button, Dialog, DialogTitle } from '@mui/material';
import { Icon } from '../Icon';

export const ListChooser = ({ open, onClose, spellId }) => {
    const { user } = useContext(AuthContext);
    const { toast } = useContext(ToastContext);
    const navigate = useNavigate();
    const [ spellLists, setSpellLists ] = useState([]);

    useEffect(() => {
        if(user?.uid) {
            const q = query(collection(db, 'spellLists'), where('userId', '==', user?.uid));
            const unsub = onSnapshot(q, snapshot => 
                setSpellLists(snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                })))
            );

            return () => unsub();
        }
    }, [user?.uid]);

    const handleCreate = () => {
        navigate(`/lists/edit?spellId=${spellId}`);
    };

    const handleSelect = (list) => {
        const docRef = doc(db, 'spellLists', list.id);

        updateDoc(
            docRef, 
            listHasSpell(list, spellId) 
                ? removeSpell(list, spellId) 
                : addSpell(list, spellId)
        ).then(() => {
            toast(`Spell successfully ${listHasSpell(list, spellId) ? 'removed' : 'added'}`);
            onClose();
        });
    };

    const addSpell = (list, spellId) => ({
        ...list,
        spells: [...new Set([
            ...list.spells,
            spellId
        ])]
    });

    const removeSpell = (list, spellId) => ({
        ...list,
        spells: list.spells.filter(s => s !== spellId)
    });

    const handleClose = () => {
        onClose();
    };

    const listHasSpell = (list, spellId) => (
        list.spells.includes(spellId)
    );

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Choose List</DialogTitle>
            <div className="ListChooser">
                <Button 
                    variant='outlined' 
                    color="secondary"
                    onClick={handleCreate}
                >
                    <Icon name="plus" size={12} />&nbsp; Create new list
                </Button>
                {spellLists.map((list) => (
                    <Button 
                        key={list.id} 
                        variant={listHasSpell(list, spellId) ? 'contained' : 'outlined'} 
                        onClick={() => handleSelect(list)}
                    >
                        {list.name}
                    </Button>
                ))}
            </div>
        </Dialog>
    );
};